import { IconCredit } from "@icons/index";
import { Popover } from "antd";
import { Trans } from "react-i18next";
import "./index.scss";

interface CostPopoverPorps {
  text?: string;
  children: React.ReactNode;
  open?: boolean; // true: hover 时展示, false: 不展示
  cost?: number | string; // 消耗的积分
  onOpenChange?: (open: boolean) => void;
}

const CostPopover = ({ text, children, open = true, cost = 1, onOpenChange }: CostPopoverPorps) => {
  // open 为 false 时禁用 popover
  if (!open) {
    return <>{children}</>;
  }

  return (
    <Popover
      overlayClassName="Component-Cost-Popover"
      content={
        <div className="flex gap-[2px] justify-center items-center p-[12px] text-kds-fg text-[14px] font-normal">
          <span className="mr-[2px]">{text || <Trans>Cost</Trans>}</span>
          <IconCredit width={16} height={16} className=""></IconCredit>
          <span className="font-semibold">{cost}</span>
        </div>
      }
      trigger="hover"
      onOpenChange={onOpenChange}
    >
      {children}
    </Popover>
  );
};

export default CostPopover;
